import { MultiSelect } from 'primereact/multiselect';
import React from 'react';
import { MyFilesStatusOptions } from '../../../../../constants/SlectOptionConstants';

const StatusDropdown = ({ filterFilesStatusData, setFilterFilesStatusData, isShowCompleted }) => {
  const handleChangeStatus = (e) => {
    const value = e.value;
    setFilterFilesStatusData(value);
  };
  return (
    <>
      <label>Status</label>
      <MultiSelect
        value={filterFilesStatusData}
        onChange={handleChangeStatus}
        options={
          isShowCompleted ? MyFilesStatusOptions : MyFilesStatusOptions.filter((option) => option.value !== 'submitted')
        }
        optionLabel="label"
        optionValue="value"
        placeholder="Select Status"
        className="w-full md:w-20rem"
        style={{
          height: '50px',
          transition: 'background-color 0.1s ease',
          width: '230px',
          zIndex: '1060 !important',
        }}
      />
    </>
  );
};

export default StatusDropdown;
